import React, { forwardRef, useState, useEffect } from "react";
import firebase from "../../config/Firebase";
import { useData } from "../../context/DataContext";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import "./dashboard.css";
import { useAuth } from "../../context/AuthContext";
import { Button, ButtonGroup } from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import AddBox from "@material-ui/icons/AddBox";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Moment from "react-moment";
import TopTick from "./TopTick";
import moment from "moment-timezone";
import RangeSlider from "../utils/RangeSlider";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const Dashboard = () => {
  const { tables: rows, ...data } = useData();
  const [filteredData, setData] = useState(null);
  const [rangeValue, setRange] = useState(null);

  useEffect(() => {
    setData(rows);
  }, []);

  useEffect(() => {
    if (rangeValue !== null) {
      console.log(rangeValue[0] * 10000, rangeValue[1] * 10000);
      let x = [];
      x = rows.filter(
        (x) =>
          x.formatted_premium >= rangeValue[0] * 100000 &&
          x.formatted_premium <= rangeValue[1] * 100000
      );
      console.log(x);
      setData(x);
    }
  }, [rangeValue]);

  const { activeUser } = useAuth();
  const columns = [
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "ticker",
      title: "Ticker",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "order_type",
      title: "Type",
      render: (params) =>
        params.order_type === "Call" ? (
          <div className="text-success-2 font-weight-bold">
            <span className="h6 mb-0 mr-1">&#8679;</span>
            {params.order_type}
          </div>
        ) : (
          <div className="text-danger font-weight-bold">
            <span className="h6 mb-0 mr-1">&#8681;</span>
            {params.order_type}
          </div>
        ),
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      defaultSort: "desc",
      field: "time",
      title: "Time",
      render: (params) => (
        <Moment fromNow>
          {moment.tz(params.time, "YYYY-MM-DD hh:mm:ss", "America/New_York")}
        </Moment>
      ),
      type: `datetime`,
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "order_num",
      title: "Quantity",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "executed_price",
      title: "Price",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "expire_date",
      title: "Expiration",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "strike",
      title: "Strike",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "spot_price",
      title: "Stock",
    },
    {
      cellStyle: {
        width: 120,
        padding: "5px 15px",
        fontSize: 12,
        color: "#E9626C",
        fontWeight: 700,
      },
      headerStyle: {
        color: "#E9626C",
        fontWeight: 700,
      },
      field: "premium",
      title: "Premium",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "implied_volatility",
      title: "IV",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "delta",
      title: "Delta",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "initial_order",
      title: "Initiation",
    },
    {
      cellStyle: {
        width: 120,
        padding: "10px 15px",
        fontSize: 12,
        textAlign: "center",
      },
      field: "initial_order",
      title: "Sentiment",
      render: (params) =>
        params.initial_order === "sell" ? (
          <Button
            class="btn-call border-0"
            variant="contained"
            color="secondary"
            disabled
          >
            {params.initial_order}
          </Button>
        ) : (
          <Button
            class="btn-put border-0"
            variant="contained"
            color="secondary"
            disabled
          >
            {params.initial_order}
          </Button>
        ),
    },
    activeUser.role === "admin"
      ? {
          field: "id",
          cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
          title: "Handlers",
          render: (params) => (
            <ButtonGroup className="btn-group">
              <Button
                variant="contained"
                color="secondary"
                style={{ fontSize: `0.6rem` }}
                onClick={() => data.delete("tables", params.id)}
                startIcon={<DeleteIcon />}
              ></Button>
              <Button
                component={Link}
                variant="contained"
                startIcon={<CreateIcon />}
                style={{ fontSize: `0.6rem` }}
                to={`/panel/edit/tables/${params.id}`}
              ></Button>
            </ButtonGroup>
          ),
        }
      : null,
  ].filter((el) => el);

  return (
    <div className="bg-light-2" style={{ fontSize: `0.8rem` }}>
      <section className="pt-5 pb-5">
        <div className="container-fluid mb-5">
          <TopTick></TopTick>
        </div>
        <div className="container-fluid mb-5">
          {/* <h1 className="font-weight-bold my-3 py-3">Unusual Option Activity Tracker</h1> */}
          <div className="shadow border p-4 rounded-xl mx-xl-3 bg-white">
            <div className="mb-4">
              <h6 className="font-weight-bold mb-3">
                Filter By premium amount
              </h6>
              <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                <RangeSlider setRange={setRange} type="real" />
                <Link to="/database" className="btn btn-call rounded-pill px-3">
                  <div className="d-flex align-items-center">
                    <span className="mr-1 small">
                      <ArrowUpwardIcon style={{ fontSize: 25 }} />
                    </span>
                    <span>Historical Datasbase</span>
                  </div>
                </Link>
              </div>
              <MaterialTable
                style={{ border: 0, boxShadow: "unset" }}
                title=""
                options={{
                  // filtering: true,
                  pageSize: 20,
                  pageSizeOptions: [20, 50, 100],
                  headerStyle: {
                    padding: "5px 15px",
                    // textAlign: 'center',
                    backgroundColor: "#847DF9",
                    color: "#FFF",
                  },
                  rowStyle: (x, index) => {
                    console.log(index);
                    if (index % 2) {
                      return { backgroundColor: "#D9E2F3" };
                    }
                  },
                }}
                data={filteredData}
                icons={tableIcons}
                columns={columns}
              />
            </div>
            {activeUser.role === "admin" ? (
              <>
                <Link
                  to={"/panel/add/tables"}
                  style={{ fontSize: `0.8rem` }}
                  className="btn btn-primary text-capitalize"
                >
                  Add Products{" "}
                </Link>
                <button
                  style={{ fontSize: `0.8rem` }}
                  className="btn btn-primary text-capitalize mx-5 d-inline-block"
                  onClick={() => firebase.auth().signOut()}
                >
                  {" "}
                  Logout{" "}
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
